module.exports = __webpack_public_path__ + "media/images/common/icon/icon-tw-w-79529fb569edccbdc92d4c6e01e40fc0.svg";